import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../components/Button";
import { Spacer } from "../editor/EditorHelpers";
import { CertificateContainer, ChallengeButtonBar, ChallengeLearnMore, ChallengeSubheader } from "./ChallengeHelpers";
import { useTranslation } from "react-i18next";
import { useChallenge } from "./useChallenge";
import { CerfificateFromProgress } from "./CertificateFromProgress";



interface TheirChallengeProps {
  ownCid: string;
  cid: string;
}

export const TheirChallenge: React.FC<TheirChallengeProps> = ({
  ownCid
}) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const [isLearnMoreOpen, setLearnMoreOpen] = useState(false);
  const [scale, setScale] = useState(1000 / 2322); // default
  const { name, processedProgress } = useChallenge();
  const navigate = useNavigate();

  useEffect(() => {
    function updateScale() {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        console.log("setScale", width)
        setScale(width / 2322);
      }
    }

    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, []);

  const handleJoin = () => {
    // Current path: /challenge/y7gaH9
    const parts = location.pathname.split('/'); // ["", "challenge", "y7gaH9"]

    if (parts.length >= 3 && parts[1] === 'challenge') {
      const newPath = `/challenge/join/${parts[2]}`; 
      navigate(newPath);
    } else {
      // fallback if structure isn't as expected
      navigate('/challenge/join');
    }
  };

  const handleGoToMyOwnChallenge = () => {
    navigate('/challenge/' + ownCid);
  };

  const header = name
    ? t('challenge.their-challenge.named.header', { name })
    : t('challenge.their-challenge.unnamed.header');

  return (
    <>
      <Header>{header}</Header>
      <ChallengeSubheader>{t('challenge.their-challenge.subheader')}</ChallengeSubheader>
      {<ChallengeButtonBar>
        <Spacer style={{flexGrow: 1}} />
        <SecondaryButton onClick={() => setLearnMoreOpen(true)}>{t('learn-more.button')}</SecondaryButton>
        {ownCid 
          ? <PrimaryButton onClick={handleGoToMyOwnChallenge}>{t('challenge.go-to-my-own-challenge.button')}</PrimaryButton>
          : <PrimaryButton onClick={handleJoin}>{t('challenge.join-challenge.button')}</PrimaryButton>
        }
        <Spacer style={{flexGrow: 1}} />
      </ChallengeButtonBar>}
      <CertificateContainer ref={containerRef}>
        <CerfificateFromProgress
          width={2322}
          height={1220}
          scale={scale}
          name={name}
          processedProgress={processedProgress}
        />
      </CertificateContainer>

      {isLearnMoreOpen && <ChallengeLearnMore onClose={() => setLearnMoreOpen(false)} />}
    </>
  )
}

const Header = styled.h1`

`
